import type { AddParticipantApiResponse, GroupStatus, GroupStatusApiResponse } from '@/domain/groups/types'

export interface GroupMapper {
  map: (apiResponse?: GroupStatusApiResponse) => GroupStatus
  mapAddParticipant: (apiResponse: AddParticipantApiResponse) => GroupStatus
}

export const createGroupsMapper: () => GroupMapper = () => {
  const map = (apiResponse?: GroupStatusApiResponse): GroupStatus => {
    return {
      isValid: apiResponse?.isValid ?? false,
      groupName: apiResponse?.groupName ?? '',
      status: mapStatus(apiResponse?.nonValidReasons),
      childBookingNumber: apiResponse?.availableSlot?.bookingNumber ?? 0,
      bookingCustomerId: apiResponse?.availableSlot?.bookingCustomerId ?? 0,
      roomSelectionIsEnabled: apiResponse?.hasRoomSelection ?? false,
      pinCodeIsRequiredForRoomSelection: apiResponse?.roomsHavePinCode ?? false,
    }
  }

  const mapAddParticipant = (apiResponse: AddParticipantApiResponse): GroupStatus => {
    return {
      isValid: apiResponse.isSuccess ?? false,
      groupName: apiResponse?.data?.groupName ?? '',
      status: apiResponse.isSuccess ? 'success' : 'error',
      childBookingNumber: apiResponse?.data?.bookingNumber ?? 0,
      bookingCustomerId: apiResponse?.data?.bookingCustomerId ?? 0,
      errorReason: apiResponse?.data?.errorReason ?? 'None',
    }
  }

  return {
    map,
    mapAddParticipant,
  }
}

function mapStatus(nonValidReasons: string[] | null | undefined): 'expired' | 'success' | 'full' | 'blocked' | 'error' {
  if (nonValidReasons && nonValidReasons.length === 0) {
    return 'success'
  }

  switch (nonValidReasons?.[0]) {
    case 'OccupancyFull':
      return 'full'
    case 'SubscriptionDateLimitReached':
      return 'expired'
    case 'GroupBookingIsBlocked':
      return 'blocked'
    default:
      return 'error'
  }
}
